<app-modal-container
  [innerModal]="true"
  [buttons]="modalButtons"
  [bigSize]="false"
  (applyButtonClicked)="confirm.emit(countedPeriod)"
  (closeButtonClicked)="closeModal.emit()"
  (dismissButtonClicked)="closeModal.emit()">

  <div class="vertical-container-simple column-gap-1">
    <app-selector
      *ngIf="countedPeriodType !== 'Final closing'"
      [title]="'From'"
      [data]="selectorData"
      [selectedItem]="'Initial closing'"
      [isNotInTable]="true"
      (itemEmitter)="chooseTypeFrom($event)">
    </app-selector>
    <app-input *ngIf="baseType === 'Initial closing'"
      [title]="'Initial closing'"
      [additionalClass]="'disabled'"
      [input]="fund?.initialClosing ? fund.initialClosing : 'No date'">
    </app-input>
    <app-input *ngIf="baseType === 'Final closing'"
      [title]="'Final closing'"
      [additionalClass]="'disabled'"
      [input]="fund?.finalClosing ? fund.finalClosing : 'No date'">
    </app-input>
    <app-input *ngIf="baseType === 'Investment period'"
      [title]="'Investment period'"
      [additionalClass]="'disabled'"
      [input]="fund?.investmentPeriod ? fund.investmentPeriod : 'No date'">
    </app-input>
    <app-input
      [title]="'Years'"
      [separator]="'separator.0'"
      (inputChange)="addedYears = $event; addDays()">
    </app-input>
    <app-input
      [title]="'Months'"
      [separator]="'separator.0'"
      (inputChange)="addedMonths = $event; addDays()">
    </app-input>
    <app-input
      [title]="'Days'"
      [separator]="'separator.0'"
      (inputChange)="addedDays = $event; addDays()">
    </app-input>
    <app-input
      [additionalClass]="'disabled'"
      [placeholder]="'yyyy-mm-dd'"
      [title]="countedPeriodType"
      [input]="countedPeriod"
      (inputChange)="countedPeriod = $event">
    </app-input>
  </div>
</app-modal-container>
